import { render } from "./DetailedAnalytics.vue?vue&type=template&id=4b3814d6"
import script from "./DetailedAnalytics.vue?vue&type=script&lang=js"
export * from "./DetailedAnalytics.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__